//BELOW TS WORKS BUT AI BTN IS MISALIGNED AFTER CLICKING ON THE ELEMENT//
import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  AfterViewChecked
} from '@angular/core';
import { Subscription } from 'rxjs';
// import { TourService, TourStep } from '../tour.service';
import { TourStep, TourService } from 'src/app/authentication/tour.service'; 
import { Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-tour-overlay',
  templateUrl: './tour-overlay.component.html',
  styleUrls: ['./tour-overlay.component.scss']
})
export class TourOverlayComponent implements OnInit, OnDestroy, AfterViewChecked {
  stepData: TourStep | null = null;
  rect: DOMRect | null = null;
  visible = false;
  blockedMessage = false;

  private stepSub!: Subscription;
  private menuToggleSub!: Subscription;
  private initialNavigationSub?: Subscription;
  private firstVisitTourTimeout?: ReturnType<typeof setTimeout>;
  private mutationObservers: MutationObserver[] = [];
  private readonly MAX_ATTEMPTS = 200;
  private readonly FIRST_VISIT_TOUR_KEY = 'clarichatFirstVisitTourShown';
  private menuObserver?: MutationObserver;

  private readonly TOGGLE_BTN_ID = 'menuToggleBtn';
  private readonly INJECTED_STYLE_ID = 'tour-disable-menu-toggle-style';
  private readonly INJECTED_GLOBAL_TOUR_STYLE_ID = 'tour-global-zindex-style';
  private readonly WEB_SEARCH_SECTION_ID = 'webSearchSection';

  constructor(private tour: TourService,
     private router: Router
  ) {}
ngOnInit(): void {
  this.stepSub = this.tour.currentStep$.subscribe(() => this.updateStep());
  this.menuToggleSub = (this.tour as any).menuToggleRequest?.subscribe?.(() => {});
  document.addEventListener('click', this.onMenuClick);
  document.addEventListener('click', this.preventMenuToggleClickCapture, true);
  this.observeMenuState();

    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(evt =>
    document.addEventListener(evt, this.tourBlockerHandler, true)
  );

  // (optional) block keyboard shortcuts while tour is active
  document.addEventListener('keydown', this.tourBlockerHandler, true);

  if (this.router.navigated) {
    this.scheduleFirstVisitTour(this.router.url);
  } else {
    this.initialNavigationSub = this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(event => this.scheduleFirstVisitTour(event.urlAfterRedirects));
  }
}



  ngOnDestroy(): void {
    this.enableScroll();
    this.stepSub?.unsubscribe();
    this.menuToggleSub?.unsubscribe();
    this.initialNavigationSub?.unsubscribe();
    if (this.firstVisitTourTimeout) {
      clearTimeout(this.firstVisitTourTimeout);
    }
    document.removeEventListener('click', this.onMenuClick);
    document.removeEventListener('click', this.preventMenuToggleClickCapture, true);
    this.mutationObservers.forEach(obs => obs.disconnect());
    this.menuObserver?.disconnect();
    this.resetPointerEvents();
    this.enableToggleButton();
    this.enableTextarea();
    this.enableWebSearchSection();
    this.removeGlobalTourStyle();
    this.enableScroll();
  }
// ===================== TOUR HANDLER =====================
  private scheduleFirstVisitTour(url: string): void {
    if (!this.isFirstVisitTourRoute(url)) {
      return;
    }

    this.firstVisitTourTimeout = setTimeout(() => this.startFirstVisitTour(url), 100);
  }

  private startFirstVisitTour(initialUrl: string, attempt = 0): void {
    if (
      !this.isFirstVisitTourRoute(this.router.url) ||
      !this.isFirstVisitTourRoute(initialUrl) ||
      localStorage.getItem(this.FIRST_VISIT_TOUR_KEY)
    ) {
      return;
    }

    const firstStepElement = document.getElementById('brandingClariChat');
    const firstStepRect = firstStepElement?.getBoundingClientRect();
    if (!firstStepRect || firstStepRect.width === 0 || firstStepRect.height === 0) {
      if (attempt < 20) {
        this.firstVisitTourTimeout = setTimeout(
          () => this.startFirstVisitTour(initialUrl, attempt + 1),
          100
        );
      }
      return;
    }

    localStorage.setItem(this.FIRST_VISIT_TOUR_KEY, 'true');
    this.startTour();
  }

  private isFirstVisitTourRoute(url: string): boolean {
    const path = url.split('?')[0].split('#')[0].replace(/\/$/, '');
    return path === '/ai/clarity' || path === '/ai/clarichat';
  }

  startTour() {
    const steps: TourStep[] = [
      { elementId: 'brandingClariChat', title: '<span class="first-line">The Future Awaits</span>', description: '<span class="line-beige">One Prompt</span><br><br><span class="line-beige">Competitive Accuracy</span><br><br><span class="line-beige">1-6 Scored Answers</span><br><br><span class="line-beige">Always Context</span><br><br><span class="line-beige">Top Selection of AI Models</span><br><br><span class="line-beige last-line">The AI Democracy</span>' },
      { elementId: 'previousPromptsBtn', title: 'My Prompts', description: 'Your best prompts live here. Reuse them instantly.' },
      { elementId: 'modelSpecsSection', title: 'Bio', description: 'Tap this — it reveals what your AI is REALLY capable of.' },
      { elementId: 'aiCatalogBtn', title: 'AI Models', description: 'This is where the real advantage lives — the right model can deliver 10× better results.' },
      { elementId: 'modelSpecsSection', title: 'Bio', description: 'Tap this — it reveals what your AI is REALLY capable of.' },
      { elementId: 'moreSection', title: 'More Section', description: 'Hidden power tools inside. You’re gonna want this.' },
      { elementId: 'effort', title: 'Reasoning Depth', description: 'Dial up the brainpower. Go from quick to genius-level.' },
      { elementId: 'chatInputTextarea', title: 'Your Text Area', description: 'Drop your idea here — we’ll turn it into something unreal.' },
      { elementId: 'sendMessageButton', title: 'Send Button', description: 'Hit send and watch the AI come alive.' },
      { elementId: 'attachImageButton', title: 'Attach Image', description: 'Upload a photo — the AI will dissect it like a pro.' },
      { elementId: 'micButton', title: 'Voice Input', description: 'Talk instead of type. It feels futuristic.' },
      { elementId: 'advisorFab', title: 'Advisor Button', description: 'This floating Advisor button opens your Coach menu. You can drag it anywhere on the screen, and it stays accessible while you work.' },
      { elementId: 'placeholderNavArrows', title: 'Choose a Model', description: 'Preview a few featured models here. Open the AI Selector to access many more.' },
      { elementId: 'profileMenuSection', title: 'Your Profile', description: 'Your command center — settings, upgrades, everything.' },
      { elementId: 'loginLink', title: 'Log In', description: 'Log in to unlock the full ClariChat experience.' },
      { elementId: 'aiExecsLink', title: 'GroupChat', description: 'Ask once. Get answers from multiple AIs. Instant advantage.' },
      { elementId: 'menuToggleBtn', title: 'Side Menu', description: 'Open this — the real power features are in here.', openMenu: true },
      { elementId: 'claritools', title: 'Clarity ToolKit', description: 'This is your cheat code. Don’t skip it.' },
    ];

  this.tour.startTour(steps);
}
  
  ngAfterViewChecked(): void {
    if (this.visible) this.adjustTooltipPosition();
  }

  private updateStep(): void {
    const current = this.tour.currentStep$.getValue();
    if (!current) {
      this.clearOverlay();
      return;
    }

    const el = document.getElementById(current.elementId);
    if (!el) {
      this.clearOverlay();
      return;
      }
      const r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) {
      this.clearOverlay();
      return;
      }

    this.stepData = current;
    
    // Special handling for brandingClariChat - highlight the entire branding area including the logo image
    if (current.elementId === 'brandingClariChat') {
      // Use requestAnimationFrame to ensure DOM is fully laid out, then calculate with image
      requestAnimationFrame(() => {
        this.calculateBrandingRectWithImage(el);
      });
      // Set initial rect immediately, will be updated in next frame
      this.rect = el.getBoundingClientRect();
    } else {
      this.rect = el.getBoundingClientRect();
    }
    
    this.visible = true;

    const mainMenu = document.getElementById('mainMenuContainer');
    const isMenuOpen = this.isMenuCurrentlyOpen(mainMenu);

    if (this.stepData.openMenu && isMenuOpen) {
      this.stepData = { ...this.stepData, openMenu: false };
    }

    // FIXED: behavior must be 'auto' | 'smooth', 'instant' is invalid
    el.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });

    this.observePanelExpansion(el);
    this.checkDropdownState();
    this.updatePointerEvents();

    if (this.stepData?.elementId === 'chatInputTextarea') {
      this.disableTextarea();
    } else {
      this.enableTextarea();
    }

    if (this.stepData?.elementId === this.WEB_SEARCH_SECTION_ID) {
      this.disableWebSearchSection();
    } else {
      this.enableWebSearchSection();
    }

    this.injectGlobalTourStyle();
    setTimeout(() => this.adjustTooltipPosition(), 300);
    if (this.stepData) {
  this.disableScroll(); // disable scroll while tour is active
} else {
  this.enableScroll(); // enable scroll if no step
}

  }

  private calculateBrandingRectWithImage(el: HTMLElement): void {
    const anchorRect = el.getBoundingClientRect();
    const image = el.querySelector('img.shrink.tealmeal') as HTMLImageElement;
    
    if (image) {
      // Check if image is loaded
      if (image.complete && image.naturalWidth > 0) {
        const imageRect = image.getBoundingClientRect();
        // Calculate rect that includes both anchor and image
        this.rect = {
          left: anchorRect.left,
          top: Math.min(anchorRect.top, imageRect.top),
          right: Math.max(anchorRect.right, imageRect.right),
          bottom: Math.max(anchorRect.bottom, imageRect.bottom),
          width: Math.max(anchorRect.right, imageRect.right) - anchorRect.left,
          height: Math.max(anchorRect.bottom, imageRect.bottom) - Math.min(anchorRect.top, imageRect.top),
          x: anchorRect.left,
          y: Math.min(anchorRect.top, imageRect.top),
          toJSON: () => ({})
        } as DOMRect;
        this.adjustTooltipPosition();
        return;
      } else {
        // Image not loaded yet, wait for it to load
        image.onload = () => {
          const imageRect = image.getBoundingClientRect();
          this.rect = {
            left: anchorRect.left,
            top: Math.min(anchorRect.top, imageRect.top),
            right: Math.max(anchorRect.right, imageRect.right),
            bottom: Math.max(anchorRect.bottom, imageRect.bottom),
            width: Math.max(anchorRect.right, imageRect.right) - anchorRect.left,
            height: Math.max(anchorRect.bottom, imageRect.bottom) - Math.min(anchorRect.top, imageRect.top),
            x: anchorRect.left,
            y: Math.min(anchorRect.top, imageRect.top),
            toJSON: () => ({})
          } as DOMRect;
          this.adjustTooltipPosition();
        };
        // Set a timeout fallback in case image never loads
        setTimeout(() => {
          if (!this.rect || this.rect.right <= anchorRect.right) {
            const imageRect = image.getBoundingClientRect();
            if (imageRect.width > 0) {
              this.rect = {
                left: anchorRect.left,
                top: Math.min(anchorRect.top, imageRect.top),
                right: Math.max(anchorRect.right, imageRect.right),
                bottom: Math.max(anchorRect.bottom, imageRect.bottom),
                width: Math.max(anchorRect.right, imageRect.right) - anchorRect.left,
                height: Math.max(anchorRect.bottom, imageRect.bottom) - Math.min(anchorRect.top, imageRect.top),
                x: anchorRect.left,
                y: Math.min(anchorRect.top, imageRect.top),
                toJSON: () => ({})
              } as DOMRect;
              this.adjustTooltipPosition();
            }
          }
        }, 100);
      }
    }
    
    // Fallback: use anchor rect (should include image if it's a child)
    // But extend right to ensure we capture the image
    const allChildren = Array.from(el.children) as HTMLElement[];
    let maxRight = anchorRect.right;
    allChildren.forEach(child => {
      const childRect = child.getBoundingClientRect();
      maxRight = Math.max(maxRight, childRect.right);
    });
    
    this.rect = {
      left: anchorRect.left,
      top: anchorRect.top,
      right: maxRight,
      bottom: anchorRect.bottom,
      width: maxRight - anchorRect.left,
      height: anchorRect.height,
      x: anchorRect.left,
      y: anchorRect.top,
      toJSON: () => ({})
    } as DOMRect;
    this.adjustTooltipPosition();
  }

  private clearOverlay(): void {
    this.stepData = null;
    this.rect = null;
    this.visible = false;
    this.blockedMessage = false;
    this.resetPointerEvents();
    this.enableTextarea();
    this.enableWebSearchSection();
    this.removeGlobalTourStyle();
    this.enableScroll();
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.stepData) this.updateStep();
    this.adjustTooltipPosition();
  }

  private observePanelExpansion(el: HTMLElement) {
    this.mutationObservers.forEach(obs => obs.disconnect());
    this.mutationObservers = [];

    const observer = new MutationObserver(() => {
      if (this.stepData && el.id === this.stepData.elementId) {
        this.rect = el.getBoundingClientRect();
        this.adjustTooltipPosition();
        this.checkDropdownState();
      }
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      subtree: true
    });

    this.mutationObservers.push(observer);
  }

  private observeMenuState(): void {
    const menu = document.getElementById('mainMenuContainer');
    if (!menu) return;

    this.menuObserver = new MutationObserver(() => {
      if (!this.stepData) return;
      const isMenuOpen = this.isMenuCurrentlyOpen(menu);
      if (this.stepData.openMenu && isMenuOpen) {
        this.stepData = { ...this.stepData, openMenu: false };
      }
    });

    this.menuObserver.observe(menu, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  private isMenuCurrentlyOpen(menu: HTMLElement | null): boolean {
    if (!menu) return false;
    const hasOpenClass =
      menu.classList.contains('open') ||
      menu.classList.contains('expanded') ||
      menu.classList.contains('active');
    const isVisible = menu.offsetParent !== null;
    return hasOpenClass || isVisible;
  }

  private preventMenuToggleClickCapture = (event: Event) => {
    if (!this.visible && !this.stepData) return;
    const tgt = event.target as HTMLElement | null;
    if (!tgt) return;

    const btn = document.getElementById(this.TOGGLE_BTN_ID);
    if (!btn) return;

    if (btn.contains(tgt) || tgt === btn) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.disableToggleButton();
    }
  };

  private removePreventStyling(): void {
    const btn = document.getElementById(this.TOGGLE_BTN_ID);
    if (!btn) return;
    btn.removeAttribute('aria-disabled');
    btn.style.opacity = '';
    btn.style.cursor = '';
    btn.classList.remove('tour-disabled-toggle');
    this.removeInjectedStyle();
  }

  private onMenuClick = (event: MouseEvent) => {
    if (!this.stepData) return;

    const highlightEl = document.getElementById(this.stepData.elementId);
    if (!highlightEl) return;

    const clickedEl = event.target as HTMLElement;

    if (!highlightEl.contains(clickedEl)) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }

    setTimeout(() => {
      const expandedPanel = document.getElementById(this.stepData!.elementId);
      if (expandedPanel) this.rect = expandedPanel.getBoundingClientRect();
      this.checkDropdownState();
    }, 250);
  };

  private checkDropdownState(): void {
    if (!this.stepData) return;
    const currentPanel = document.getElementById(this.stepData.elementId);
    if (!currentPanel) return;
    this.blockedMessage = currentPanel.classList.contains('mat-expanded');
  }

  private adjustTooltipPosition(): void {
    const tooltip = document.querySelector('.tour-tooltip') as HTMLElement;
    if (!tooltip || !this.rect) return;

    const tooltipRect = tooltip.getBoundingClientRect();
    const highlightRect = this.rect;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const padding = 12;

    let top = highlightRect.bottom + padding;
    let left = highlightRect.left;

    const sideMenu = document.getElementById('mainMenuContainer');
    const menuWidth = sideMenu && sideMenu.offsetParent !== null ? sideMenu.offsetWidth : 0;
    if (menuWidth > 0 && left < menuWidth + padding) left = menuWidth + padding;

    if (top + tooltipRect.height > vh - padding) top = highlightRect.top - tooltipRect.height - padding;
    if (top < padding) top = padding;
    if (left + tooltipRect.width > vw - padding) left = vw - tooltipRect.width - padding;
    if (left < padding) left = padding;

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;

    if (tooltipRect.height > vh - 2 * padding) {
      tooltip.style.maxHeight = `${vh - 2 * padding}px`;
      tooltip.style.overflowY = 'auto';
    } else {
      tooltip.style.maxHeight = '';
      tooltip.style.overflowY = '';
    }
  }

  private tourBlockerHandler = (event: Event) => {
  if (!this.stepData || !this.visible) return;

  const target = event.target as HTMLElement | null;
  if (!target) return;

  // Allow tooltip interactions
  if (target.closest('.tour-tooltip')) return;

  // OPTIONAL: if you want clicking the HIGHLIGHTED element to NOT end the tour,
  // uncomment this block to ignore those clicks (still blocked from app behavior below)
  // const highlighted = document.getElementById(this.stepData.elementId);
  // if (highlighted && highlighted.contains(target)) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   (event as any).stopImmediatePropagation?.();
  //   return;
  // }

  event.preventDefault();
  event.stopPropagation();
  (event as any).stopImmediatePropagation?.();

  this.tour.endTour();
};



private updatePointerEvents(): void {
  document.querySelectorAll('body *').forEach((el: HTMLElement) => {
  });

  document.querySelectorAll('.tour-tooltip, .tour-tooltip *').forEach((el: HTMLElement) => {
    el.style.pointerEvents = 'auto';
  });

  const highlighted = this.stepData && document.getElementById(this.stepData.elementId);
  if (highlighted) {
    highlighted.style.pointerEvents = 'auto';
    highlighted.querySelectorAll('*').forEach(child => (child as HTMLElement).style.pointerEvents = 'auto');
  }

  const mainMenu = document.getElementById('mainMenuContainer');
  if (mainMenu && highlighted && mainMenu.contains(highlighted)) {
    mainMenu.querySelectorAll('*').forEach((el: HTMLElement) => {
      el.style.pointerEvents = 'none';
    });
    highlighted.style.pointerEvents = 'auto';
    highlighted.querySelectorAll('*').forEach((child: any) => (child.style.pointerEvents = 'auto'));
  }

  const toggleBtn = document.getElementById(this.TOGGLE_BTN_ID);
  if (toggleBtn) {
    toggleBtn.setAttribute('aria-disabled', 'true');
    toggleBtn.classList.add('tour-disabled-toggle');
    this.injectDisableStyle();
  }
    // Block specific sub-menu items
  const blockedTitles = [
    'Deep Search', 'Writing IQ', 'Personality Type',
    'Funny Duck', 'Rhyme Duck', 'Inspirational Duck', 'Song Duck',
    'The Image Musketeers', 'Video Generation', 'Transform Reading Levels', 'Power Email Tools'
  ];

  // ✅ disable all tour-blocked elements like textarea
  this.disableTourElements();
  this.disableSpecificMenuItems();

  if (this.stepData?.elementId === 'chatInputTextarea') {
    this.disableTextarea();
  } else {
    this.enableTextarea();
  }

  if (this.stepData?.elementId === this.WEB_SEARCH_SECTION_ID) {
    this.disableWebSearchSection();
  } else {
    this.enableWebSearchSection();
  }
}


  private resetPointerEvents(): void {
    document.querySelectorAll('body *').forEach((el: HTMLElement) => (el.style.pointerEvents = ''));
    this.removePreventStyling();
    this.enableToggleButton();
    this.enableTextarea();
    this.enableTourElements(); 
    this.enableSpecificMenuItems();
  }

  private isDropdownBlocked(): boolean {
    return this.blockedMessage;
  }

  next(): void {
    if (this.isDropdownBlocked()) return;
  
    const svc: any = this.tour as any;
    const steps: TourStep[] = svc.steps || [];
    if (!steps.length) return;
  
    let idx: number = typeof svc.currentStepIndex === 'number' ? svc.currentStepIndex : -1;
    let attempts = 0;
  
    while (attempts < Math.min(this.MAX_ATTEMPTS, steps.length)) {
      idx++;
  
      if (idx >= steps.length) {
        svc.currentStepIndex = steps.length;
        this.tour.endTour();
        return;
      }
  
      const candidate = steps[idx];
      const el = document.getElementById(candidate.elementId);
  
      if (el) {
        const r = el.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) {
          this.tour.goToStep(idx);
          return;
        }
      }
  
      attempts++;
    }
  
    this.tour.endTour();
  }

  prev(): void {
    if (this.isDropdownBlocked()) return;
  
    const svc: any = this.tour as any;
    const steps: TourStep[] = svc.steps || [];
    if (!steps.length) return;
  
    let idx: number = typeof svc.currentStepIndex === 'number' ? svc.currentStepIndex : steps.length;
    let attempts = 0;
  
    while (attempts < Math.min(this.MAX_ATTEMPTS, steps.length)) {
      idx--;
  
      if (idx < 0) {
        svc.currentStepIndex = 0;
        const first = steps[0];
        const firstEl = first ? document.getElementById(first.elementId) : null;
  
        if (firstEl) {
          const r = firstEl.getBoundingClientRect();
          if (r.width > 0 && r.height > 0) {
              this.tour.goToStep(0);
            return;
          }
        }
  
        this.clearOverlay();
        return;
      }
  
      const candidate = steps[idx];
      const el = document.getElementById(candidate.elementId);
  
      if (el) {
        const r = el.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) {
          this.tour.goToStep(idx);
          return;
        }
      }
  
      attempts++;
    }
  
    this.clearOverlay();
  }


  openMenuAndContinue(): void {
    const svc: any = this.tour as any;
    svc.menuToggleRequest?.next?.();
    try {
      (this.stepData as any)?.onStepAction?.();
    } catch (e) {
      console.error(e);
    }
    setTimeout(() => this.next(), 450);
  }

  skip(): void {
    this.tour.endTour();
  }

  // Disable / enable helpers
  private injectDisableStyle(): void {
    if (document.getElementById(this.INJECTED_STYLE_ID)) return;
    const css = `
      #${this.TOGGLE_BTN_ID}.tour-disabled-toggle,
      #${this.TOGGLE_BTN_ID}.tour-disabled-toggle * {
        pointer-events: none !important;
        cursor: default !important;
        transition: none !important;
        animation: none !important;
      }
    `;
    const style = document.createElement('style');
    style.id = this.INJECTED_STYLE_ID;
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  private removeInjectedStyle(): void {
    const s = document.getElementById(this.INJECTED_STYLE_ID);
    if (s) s.remove();
  }

  private disableToggleButton(): void {
    const btn = document.getElementById(this.TOGGLE_BTN_ID);
    if (!btn) return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('tour-disabled-toggle');
    btn.style.opacity = '0.55';
    btn.style.cursor = 'default';
    this.injectDisableStyle();
  }

  private enableToggleButton(): void {
    const btn = document.getElementById(this.TOGGLE_BTN_ID);
    if (!btn) return;
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('tour-disabled-toggle');
    btn.style.opacity = '';
    btn.style.cursor = '';
    this.removeInjectedStyle();
  }

  private disableTextarea(): void {
    const textarea = document.querySelector('.user-input-textarea') as HTMLTextAreaElement | null;
    if (!textarea) return;
    textarea.setAttribute('readonly', 'true');
    textarea.setAttribute('aria-disabled', 'true');
    textarea.style.pointerEvents = 'none';
    textarea.style.userSelect = 'none';
    textarea.style.cursor = 'default';
    textarea.style.opacity = '0.75';
  }

  private enableTextarea(): void {
    const textarea = document.querySelector('.user-input-textarea') as HTMLTextAreaElement | null;
    if (!textarea) return;
    textarea.removeAttribute('readonly');
    textarea.removeAttribute('aria-disabled');
    textarea.style.pointerEvents = '';
    textarea.style.userSelect = '';
    textarea.style.cursor = '';
    textarea.style.opacity = '';
  }

  private disableWebSearchSection(): void {
    const section = document.getElementById(this.WEB_SEARCH_SECTION_ID);
    if (!section) return;
    section.setAttribute('aria-disabled', 'true');
    section.style.pointerEvents = 'none';
    section.style.userSelect = 'none';
    section.style.cursor = 'default';
    section.style.opacity = '0.75';
    section.querySelectorAll('*').forEach(child => {
      (child as HTMLElement).style.pointerEvents = 'none';
      (child as HTMLElement).style.cursor = 'default';
    });
  }

  private enableWebSearchSection(): void {
    const section = document.getElementById(this.WEB_SEARCH_SECTION_ID);
    if (!section) return;
    section.removeAttribute('aria-disabled');
    section.style.pointerEvents = '';
    section.style.userSelect = '';
    section.style.cursor = '';
    section.style.opacity = '';
    section.querySelectorAll('*').forEach(child => {
      (child as HTMLElement).style.pointerEvents = '';
      (child as HTMLElement).style.cursor = '';
    });
  }

  private injectGlobalTourStyle(): void {
    if (document.getElementById(this.INJECTED_GLOBAL_TOUR_STYLE_ID)) return;

    const chatSelectors = [
      '.user-input-textarea',
      '.chat-input',
      '.chat-input-container',
      '.input-container',
      '.chat-container'
    ].join(',');

    const css = `
      app-tour-overlay,
      app-tour-overlay .tour-overlay,
      .tour-overlay,
      .tour-backdrop,
      .tour-highlight,
      .tour-tooltip {
        z-index: 2147483647 !important;
      }
      .tour-backdrop { z-index: 2147483646 !important; }
      ${chatSelectors} { position: relative !important; z-index: 0 !important; }
      ${chatSelectors} * { z-index: 0 !important; }
    `;
    const style = document.createElement('style');
    style.id = this.INJECTED_GLOBAL_TOUR_STYLE_ID;
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  private removeGlobalTourStyle(): void {
    const s = document.getElementById(this.INJECTED_GLOBAL_TOUR_STYLE_ID);
    if (s) s.remove();
  }

  getHighlightWidth(): number {
    if (!this.rect) return 127;
    // Minimum width of 127px, extend 30px to the right for better visibility
    return Math.max(127, this.rect.width + 30);
  }

  private disableScroll(): void {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  private enableScroll(): void {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
  // Add these at the top of your class
private readonly TOUR_BLOCKED_IDS = [
  'advisorFab',
  'aiCatalogBtn',
  'previousPromptsBtn',
  'modelSpecsSection',
  'effort',
  'attachImageButton',
  'micButton',
  'loginLink',
  'aiExecsLink',
  'profileMenuSection',
  'moreSection',
];

// Call this inside updatePointerEvents() along with your textarea / toggle button logic
private disableTourElements(): void {
  this.TOUR_BLOCKED_IDS.forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('aria-disabled', 'true');
    el.style.pointerEvents = 'none';
    el.style.userSelect = 'none';
    el.style.cursor = 'default';
    el.style.opacity = '0.75';
    el.querySelectorAll('*').forEach(child => {
      (child as HTMLElement).style.pointerEvents = 'none';
      (child as HTMLElement).style.cursor = 'default';
    });
  });
}

private enableTourElements(): void {
  this.TOUR_BLOCKED_IDS.forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.removeAttribute('aria-disabled');
    el.style.pointerEvents = '';
    el.style.userSelect = '';
    el.style.cursor = '';
    el.style.opacity = '';
    el.querySelectorAll('*').forEach(child => {
      (child as HTMLElement).style.pointerEvents = '';
      (child as HTMLElement).style.cursor = '';
    });
  });
}
private disableSpecificMenuItems(): void {
  const blockedTitles = [
    'Deep Search', 'Note Library', 'Side-by-Side', 'Writing IQ', 'Personality Type',
    'Funny Duck', 'Rhyme Duck', 'Inspirational Duck', 'Song Duck',
    'The Image Musketeers', 'Video Generation', 'Transform Reading Levels', 'Power Email Tools'
  ];

  const menuSpans = document.querySelectorAll('#mainMenuContainer .menu-item-title') as NodeListOf<HTMLElement>;

  menuSpans.forEach(span => {
    if (blockedTitles.includes(span.textContent?.trim() || '')) {
      const parentLink = span.closest('a');
      if (parentLink) {
        // Disable parent
        parentLink.style.pointerEvents = 'none';
        parentLink.style.cursor = 'default';
        parentLink.style.opacity = '0.6';

        // ✅ Also disable all child elements recursively
        parentLink.querySelectorAll('*').forEach(child => {
          (child as HTMLElement).style.pointerEvents = 'none';
          (child as HTMLElement).style.cursor = 'default';
        });
      }
    }
  });
}

private enableSpecificMenuItems(): void {
  const blockedTitles = [
    'Deep Search', 'Note Library', 'Side-by-Side', 'Writing IQ', 'Personality Type',
    'Funny Duck', 'Rhyme Duck', 'Inspirational Duck', 'Song Duck',
    'The Image Musketeers', 'Video Generation', 'Transform Reading Levels', 'Power Email Tools'
  ];

  const menuSpans = document.querySelectorAll('#mainMenuContainer .menu-item-title') as NodeListOf<HTMLElement>;

  menuSpans.forEach(span => {
    if (blockedTitles.includes(span.textContent?.trim() || '')) {
      const parentLink = span.closest('a');
      if (parentLink) {
        // Restore parent
        parentLink.style.pointerEvents = '';
        parentLink.style.cursor = '';
        parentLink.style.opacity = '';

        // ✅ Restore all child elements
        parentLink.querySelectorAll('*').forEach(child => {
          (child as HTMLElement).style.pointerEvents = '';
          (child as HTMLElement).style.cursor = '';
        });
      }
    }
  });
}
getHighlightStyle(): { [key: string]: string } {
  if (!this.rect) return {};

  // small padding so the glow doesn't feel clipped
  const padX = 8;
  const padY = 6;

  const top = Math.max(0, this.rect.top - padY);
  const left = Math.max(0, this.rect.left - padX);

  // Expand equally left+right, not only right
  const width = Math.min(this.rect.width + padX * 2, window.innerWidth - left);
  const height = Math.min(this.rect.height + padY * 2, window.innerHeight - top);

  return {
    top: `${top}px`,
    left: `${left}px`,
    width: `${width}px`,
    height: `${height}px`,
  };
}

}



//BELOW TS WORKS BUT AI BTN IS MISALIGNED AS SOON AS TOUR STARTS//
// import {
//   Component,
//   OnInit,
//   OnDestroy,
//   HostListener,
//   AfterViewChecked
// } from '@angular/core';
// import { Subscription } from 'rxjs';
// import { TourService, TourStep } from '../tour.service';

// @Component({
//   selector: 'app-tour-overlay',
//   templateUrl: './tour-overlay.component.html',
//   styleUrls: ['./tour-overlay.component.scss']
// })
// export class TourOverlayComponent implements OnInit, OnDestroy, AfterViewChecked {
//   stepData: TourStep | null = null;
//   rect: DOMRect | null = null;
//   visible = false;
//   blockedMessage = false;

//   private stepSub!: Subscription;
//   private menuToggleSub!: Subscription;
//   private mutationObservers: MutationObserver[] = [];
//   private readonly MAX_ATTEMPTS = 200;
//   private menuObserver?: MutationObserver;

//   // IMPORTANT: matches your button id
//   private readonly TOGGLE_BTN_ID = 'menuToggleBtn';
//   // id for injected style element
//   private readonly INJECTED_STYLE_ID = 'tour-disable-menu-toggle-style';
//   // id for temporary global z-index/style injection for topnav issue
//   private readonly INJECTED_GLOBAL_TOUR_STYLE_ID = 'tour-global-zindex-style';
//     // 🧠 added constant for web search section
//   private readonly WEB_SEARCH_SECTION_ID = 'webSearchSection';

//   constructor(private tour: TourService) {}

//   ngOnInit(): void {
//     this.stepSub = this.tour.currentStep$.subscribe(() => this.updateStep());
//     this.menuToggleSub = (this.tour as any).menuToggleRequest?.subscribe?.(() => {});
//     // onMenuClick in bubble phase so tooltip buttons still work
//     document.addEventListener('click', this.onMenuClick);
//     this.observeMenuState();

//     // capture-phase listener to block hamburger clicks (stronger control)
//     document.addEventListener('click', this.preventMenuToggleClickCapture, true);
//       this.disableScroll();
//   this.stepSub = this.tour.currentStep$.subscribe(() => this.updateStep());
//   this.menuToggleSub = (this.tour as any).menuToggleRequest?.subscribe?.(() => {});
//   document.addEventListener('click', this.onMenuClick);
//   document.addEventListener('click', this.preventMenuToggleClickCapture, true);
//   this.observeMenuState();
//   }

//   ngOnDestroy(): void {
//     this.enableScroll();
//     this.stepSub?.unsubscribe();
//     this.menuToggleSub?.unsubscribe();
//     document.removeEventListener('click', this.onMenuClick);
//     document.removeEventListener('click', this.preventMenuToggleClickCapture, true);
//     this.mutationObservers.forEach(obs => obs.disconnect());
//     this.menuObserver?.disconnect();
//     this.resetPointerEvents();
//     // ensure we remove injected style if still present
//     this.enableToggleButton();
//     // ensure textarea re-enabled
//     this.enableTextarea();
//     this.enableWebSearchSection();
//     // cleanup global tour style
//     this.removeGlobalTourStyle();
//   }

//   ngAfterViewChecked(): void {
//     if (this.visible) this.adjustTooltipPosition();
//   }

//   /** -------------------------------
//    * 🧭 Step update & positioning
//    * ------------------------------- */
//   private updateStep(): void {
//     const current = this.tour.currentStep$.getValue();
//     if (!current) {
//       this.clearOverlay();
//       return;
//     }

//     const el = document.getElementById(current.elementId);
//     if (!el || el.offsetParent === null) {
//       this.clearOverlay();
//       return;
//     }

//     this.stepData = current;
//     this.rect = el.getBoundingClientRect();
//     this.visible = true;

//     // Detect if main menu is already open
//     const mainMenu = document.getElementById('mainMenuContainer');
//     const isMenuOpen = this.isMenuCurrentlyOpen(mainMenu);

//     // If step expects to open the menu but it's already open, show Next instead
//     if (this.stepData.openMenu && isMenuOpen) {
//       this.stepData = { ...this.stepData, openMenu: false };
//     }

//     el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

//     this.observePanelExpansion(el);
//     this.checkDropdownState();
//     this.updatePointerEvents();

//     // NEW: disable textarea interaction when the current step targets the chat input
//     if (this.stepData?.elementId === 'chatInputTextarea') {
//       this.disableTextarea();
//     } else {
//       this.enableTextarea();
//     }

//       if (this.stepData?.elementId === this.WEB_SEARCH_SECTION_ID) {
//       this.disableWebSearchSection();
//     } else {
//       this.enableWebSearchSection();
//     }

//     // NEW: ensure overlay/backdrop sits above any input container stacking context,
//     // and make sure input container gets darkened like the rest.
//     // Inject a tiny global stylesheet while the tour is active.
//     this.injectGlobalTourStyle();

//     setTimeout(() => this.adjustTooltipPosition(), 300);
//   }

//   private clearOverlay(): void {
//     this.stepData = null;
//     this.rect = null;
//     this.visible = false;
//     this.blockedMessage = false;
//     this.resetPointerEvents();
//     // ensure textarea is enabled when overlay clears
//     this.enableTextarea();
//     this.enableWebSearchSection();
//     // remove global tour style when overlay clears
//     this.removeGlobalTourStyle();
//   }

//   @HostListener('window:resize')
//   onResize(): void {
//     if (this.stepData) this.updateStep();
//     this.adjustTooltipPosition();
//   }

//   /** -------------------------------
//    * 👀 Observe changes
//    * ------------------------------- */
//   private observePanelExpansion(el: HTMLElement) {
//     this.mutationObservers.forEach(obs => obs.disconnect());
//     this.mutationObservers = [];

//     const observer = new MutationObserver(() => {
//       if (this.stepData && el.id === this.stepData.elementId) {
//         this.rect = el.getBoundingClientRect();
//         this.adjustTooltipPosition();
//         this.checkDropdownState();
//       }
//     });

//     observer.observe(el, {
//       attributes: true,
//       attributeFilter: ['class', 'style'],
//       subtree: true
//     });

//     this.mutationObservers.push(observer);
//   }

//   private observeMenuState(): void {
//     const menu = document.getElementById('mainMenuContainer');
//     if (!menu) return;

//     this.menuObserver = new MutationObserver(() => {
//       if (!this.stepData) return;
//       // If current step cares about openMenu, update it live
//       const isMenuOpen = this.isMenuCurrentlyOpen(menu);
//       if (this.stepData.openMenu && isMenuOpen) {
//         this.stepData = { ...this.stepData, openMenu: false };
//       }
//     });

//     this.menuObserver.observe(menu, {
//       attributes: true,
//       attributeFilter: ['class', 'style']
//     });
//   }

//   private isMenuCurrentlyOpen(menu: HTMLElement | null): boolean {
//     if (!menu) return false;
//     const hasOpenClass =
//       menu.classList.contains('open') ||
//       menu.classList.contains('expanded') ||
//       menu.classList.contains('active');
//     const isVisible = menu.offsetParent !== null;
//     return hasOpenClass || isVisible;
//   }

//   /** -------------------------------
//    * 🔒 Block manual toggle clicks (capture-phase)
//    * ------------------------------- */
//   private preventMenuToggleClickCapture = (event: Event) => {
//     // Only block when tour overlay active/visible
//     if (!this.visible && !this.stepData) return;
//     const tgt = event.target as HTMLElement | null;
//     if (!tgt) return;

//     const btn = document.getElementById(this.TOGGLE_BTN_ID);
//     if (!btn) return;

//     if (btn.contains(tgt) || tgt === btn) {
//       // Block the click from reaching your Angular (click) handler
//       event.preventDefault();
//       event.stopImmediatePropagation();

//       // Strongly disable the button visually & functionally (style injection)
//       this.disableToggleButton();
//     }
//   };

//   private removePreventStyling(): void {
//     const btn = document.getElementById(this.TOGGLE_BTN_ID);
//     if (!btn) return;
//     btn.removeAttribute('aria-disabled');
//     btn.style.opacity = '';
//     btn.style.cursor = '';
//     btn.classList.remove('tour-disabled-toggle'); // in case other code uses this class
//     // remove injected style if any
//     this.removeInjectedStyle();
//   }

//   /** -------------------------------
//    * 🖱 Click behavior for highlighted elements
//    * ------------------------------- */
//   private onMenuClick = (event: MouseEvent) => {
//     if (!this.stepData) return;

//     const highlightEl = document.getElementById(this.stepData.elementId);
//     if (!highlightEl) return;

//     const clickedEl = event.target as HTMLElement;

//     // If click is outside the highlighted element, block it.
//     // Because this listener runs in bubble phase, tooltip elements (which are allowed via pointer-events) will not be blocked.
//     if (!highlightEl.contains(clickedEl)) {
//       event.stopPropagation();
//       event.preventDefault();
//       return;
//     }

//     // Allow clicks inside highlighted area (but hamburger is specially blocked by capture-phase handler)
//     setTimeout(() => {
//       const expandedPanel = document.getElementById(this.stepData!.elementId);
//       if (expandedPanel) this.rect = expandedPanel.getBoundingClientRect();
//       this.checkDropdownState();
//     }, 250);
//   };

//   /** -------------------------------
//    * ⚙ Tooltip & dropdown handling
//    * ------------------------------- */
//   private checkDropdownState(): void {
//     if (!this.stepData) return;
//     const currentPanel = document.getElementById(this.stepData.elementId);
//     if (!currentPanel) return;
//     this.blockedMessage = currentPanel.classList.contains('mat-expanded');
//   }

//   private adjustTooltipPosition(): void {
//     const tooltip = document.querySelector('.tour-tooltip') as HTMLElement;
//     if (!tooltip || !this.rect) return;

//     const tooltipRect = tooltip.getBoundingClientRect();
//     const highlightRect = this.rect;
//     const vw = window.innerWidth;
//     const vh = window.innerHeight;
//     const padding = 12;

//     let top = highlightRect.bottom + padding;
//     let left = highlightRect.left;

//     const sideMenu = document.getElementById('mainMenuContainer');
//     const menuWidth = sideMenu && sideMenu.offsetParent !== null ? sideMenu.offsetWidth : 0;
//     if (menuWidth > 0 && left < menuWidth + padding) left = menuWidth + padding;

//     if (top + tooltipRect.height > vh - padding) top = highlightRect.top - tooltipRect.height - padding;
//     if (top < padding) top = padding;
//     if (left + tooltipRect.width > vw - padding) left = vw - tooltipRect.width - padding;
//     if (left < padding) left = padding;

//     tooltip.style.top = `${top}px`;
//     tooltip.style.left = `${left}px`;

//     if (tooltipRect.height > vh - 2 * padding) {
//       tooltip.style.maxHeight = `${vh - 2 * padding}px`;
//       tooltip.style.overflowY = 'auto';
//     } else {
//       tooltip.style.maxHeight = '';
//       tooltip.style.overflowY = '';
//     }
//   }

//   /** -------------------------------
//    * 🔒 Pointer blocking for rest of UI
//    * ------------------------------- */
//   private updatePointerEvents(): void {
//     document.querySelectorAll('body *').forEach((el: HTMLElement) => {
//       el.style.pointerEvents = 'none';
//     });

//     document.querySelectorAll('.tour-tooltip, .tour-tooltip *').forEach((el: HTMLElement) => {
//       el.style.pointerEvents = 'auto';
//     });

//     const highlighted = this.stepData && document.getElementById(this.stepData.elementId);
//     if (highlighted) {
//       highlighted.style.pointerEvents = 'auto';
//       highlighted.querySelectorAll('*').forEach(child => (child as HTMLElement).style.pointerEvents = 'auto');
//     }

//     const mainMenu = document.getElementById('mainMenuContainer');
//     if (mainMenu && highlighted && mainMenu.contains(highlighted)) {
//       mainMenu.querySelectorAll('*').forEach((el: HTMLElement) => {
//         el.style.pointerEvents = 'none';
//       });
//       highlighted.style.pointerEvents = 'auto';
//       highlighted.querySelectorAll('*').forEach((child: any) => (child.style.pointerEvents = 'auto'));
//     }

//     // Ensure the hamburger toggle remains visually flagged while tour active
//     const toggleBtn = document.getElementById(this.TOGGLE_BTN_ID);
//     if (toggleBtn) {
//       toggleBtn.setAttribute('aria-disabled', 'true');
//       toggleBtn.classList.add('tour-disabled-toggle');
//       // also ensure injected style is present so hover/cursor are suppressed
//       this.injectDisableStyle();
//     }
//   }

//   private resetPointerEvents(): void {
//     document.querySelectorAll('body *').forEach((el: HTMLElement) => (el.style.pointerEvents = ''));
//     this.removePreventStyling();
//     this.enableToggleButton();
//     // ensure textarea re-enabled when pointer events reset
//     this.enableTextarea();
//   }

//   private isDropdownBlocked(): boolean {
//     return this.blockedMessage;
//   }

//   /** -------------------------------
//    * ⏭ Step navigation
//    * ------------------------------- */
//   next(): void {
//     if (this.isDropdownBlocked()) return;

//     const svc: any = this.tour as any;
//     const steps: TourStep[] = svc.steps || [];
//     if (!steps.length) return;

//     let idx: number = typeof svc.currentStepIndex === 'number' ? svc.currentStepIndex : -1;
//     let attempts = 0;

//     while (attempts < Math.min(this.MAX_ATTEMPTS, steps.length)) {
//       idx++;
//       if (idx >= steps.length) {
//         svc.currentStepIndex = steps.length;
//         this.tour.endTour();
//         return;
//       }

//       const candidate = steps[idx];
//       const el = document.getElementById(candidate.elementId);
//       if (el && el.offsetParent !== null) {
//         svc.currentStepIndex = idx;
//         svc.currentStep$?.next(candidate);
//         return;
//       }
//       attempts++;
//     }

//     this.tour.endTour();
//   }

//   prev(): void {
//     if (this.isDropdownBlocked()) return;

//     const svc: any = this.tour as any;
//     const steps: TourStep[] = svc.steps || [];
//     if (!steps.length) return;

//     let idx: number = typeof svc.currentStepIndex === 'number' ? svc.currentStepIndex : steps.length;
//     let attempts = 0;

//     while (attempts < Math.min(this.MAX_ATTEMPTS, steps.length)) {
//       idx--;
//       if (idx < 0) {
//         svc.currentStepIndex = 0;
//         const first = steps[0];
//         if (first && document.getElementById(first.elementId)?.offsetParent !== null) {
//           svc.currentStep$?.next(first);
//         } else {
//           this.clearOverlay();
//         }
//         return;
//       }

//       const candidate = steps[idx];
//       const el = document.getElementById(candidate.elementId);
//       if (el && el.offsetParent !== null) {
//         svc.currentStepIndex = idx;
//         svc.currentStep$?.next(candidate);
//         return;
//       }
//       attempts++;
//     }

//     this.clearOverlay();
//   }

//   openMenuAndContinue(): void {
//     const svc: any = this.tour as any;
//     svc.menuToggleRequest?.next?.();
//     try {
//       (this.stepData as any)?.onStepAction?.();
//     } catch (e) {
//       console.error(e);
//     }
//     setTimeout(() => this.next(), 450);
//   }

//   skip(): void {
//     this.tour.endTour();
//   }

//   /** -------------------------------
//    * ✨ Strong disable helpers (style injection + inline hints)
//    * ------------------------------- */

//   // Inject a style element that forcibly disables hover, pointer, animations, transitions, cursor, etc.
//   private injectDisableStyle(): void {
//     if (document.getElementById(this.INJECTED_STYLE_ID)) return;

//     const css = `
//       /* injected by tour - absolutely disable pointer / hover / animations on toggle */
//       #${this.TOGGLE_BTN_ID}.tour-disabled-toggle,
//       #${this.TOGGLE_BTN_ID}.tour-disabled-toggle * {
//         pointer-events: none !important;
//         cursor: default !important;
//         transition: none !important;
//         animation: none !important;
//         -webkit-animation: none !important;
//         transform: none !important;
//         box-shadow: none !important;
//         background: none !important;
//       }
//       /* also explicitly override pseudo-element hover styles */
//       #${this.TOGGLE_BTN_ID}.tour-disabled-toggle:hover,
//       #${this.TOGGLE_BTN_ID}.tour-disabled-toggle:focus,
//       #${this.TOGGLE_BTN_ID}.tour-disabled-toggle:active {
//         pointer-events: none !important;
//         cursor: default !important;
//         transform: none !important;
//         box-shadow: none !important;
//         background: none !important;
//       }
//     `;

//     const style = document.createElement('style');
//     style.id = this.INJECTED_STYLE_ID;
//     style.appendChild(document.createTextNode(css));
//     document.head.appendChild(style);
//   }

//   private removeInjectedStyle(): void {
//     const s = document.getElementById(this.INJECTED_STYLE_ID);
//     if (s) s.remove();
//   }

//   // Apply stronger disabling to the button: inject style and set ARIA/inline opacity
//   private disableToggleButton(): void {
//     const btn = document.getElementById(this.TOGGLE_BTN_ID);
//     if (!btn) return;

//     btn.setAttribute('aria-disabled', 'true');
//     btn.classList.add('tour-disabled-toggle');
//     // small visual hint (inline)
//     btn.style.opacity = '0.55';
//     btn.style.cursor = 'default';
//     // ensure injected stylesheet exists (with !important overrides)
//     this.injectDisableStyle();
//   }

//   // Re-enable button by removing injected style and inline hints
//   private enableToggleButton(): void {
//     const btn = document.getElementById(this.TOGGLE_BTN_ID);
//     if (btn) {
//       btn.removeAttribute('aria-disabled');
//       btn.classList.remove('tour-disabled-toggle');
//       btn.style.opacity = '';
//       btn.style.cursor = '';
//     }
//     this.removeInjectedStyle();
//   }

//   /** -------------------------------
//    * 📝 Disable / enable textarea during tour step
//    * ------------------------------- */
//   private disableTextarea(): void {
//     const textarea = document.querySelector('.user-input-textarea') as HTMLTextAreaElement | null;
//     if (!textarea) return;
//     // Make it read-only and non-interactive
//     textarea.setAttribute('readonly', 'true');
//     textarea.setAttribute('aria-disabled', 'true');
//     textarea.style.pointerEvents = 'none';
//     textarea.style.userSelect = 'none';
//     textarea.style.cursor = 'default';
//     // small visual cue
//     textarea.style.opacity = '0.75';
//   }

//   private enableTextarea(): void {
//     const textarea = document.querySelector('.user-input-textarea') as HTMLTextAreaElement | null;
//     if (!textarea) return;
//     textarea.removeAttribute('readonly');
//     textarea.removeAttribute('aria-disabled');
//     textarea.style.pointerEvents = '';
//     textarea.style.userSelect = '';
//     textarea.style.cursor = '';
//     textarea.style.opacity = '';
//   }

//     /** -------------------------------
//    * 🔒 Disable / enable Web Search section during tour step
//    * ------------------------------- */
//   private disableWebSearchSection(): void {
//     const section = document.getElementById(this.WEB_SEARCH_SECTION_ID);
//     if (!section) return;
//     section.setAttribute('aria-disabled', 'true');
//     section.style.pointerEvents = 'none';
//     section.style.userSelect = 'none';
//     section.style.cursor = 'default';
//     section.style.opacity = '0.75';
//       // ✅ Ensure children also become non-clickable even if *ngIf re-renders
//   const allChildren = section.querySelectorAll('*');
//   allChildren.forEach(child => {
//     (child as HTMLElement).style.pointerEvents = 'none';
//     (child as HTMLElement).style.cursor = 'default';
//   });
//   }

//   private enableWebSearchSection(): void {
//     const section = document.getElementById(this.WEB_SEARCH_SECTION_ID);
//     if (!section) return;
//     section.removeAttribute('aria-disabled');
//     section.style.pointerEvents = '';
//     section.style.userSelect = '';
//     section.style.cursor = '';
//     section.style.opacity = '';
//       const allChildren = section.querySelectorAll('*');
//   allChildren.forEach(child => {
//     (child as HTMLElement).style.pointerEvents = '';
//     (child as HTMLElement).style.cursor = '';
//   });
//   }

//   /** -------------------------------
//    * 🛠 Global tour z-index / input container fix
//    *
//    * When starting the tour from TopNav, some app sections (input container / chat area)
//    * create a stacking context and sit above the overlay/backdrop. Inject a short-lived
//    * global stylesheet while tour is active to:
//    *  - push overlay/backdrop to extreme z-index
//    *  - force common chat/input containers to sit below the overlay
//    * ------------------------------- */
//   private injectGlobalTourStyle(): void {
//     if (document.getElementById(this.INJECTED_GLOBAL_TOUR_STYLE_ID)) return;

//     // A targeted list of selectors that commonly wrap the chat input area.
//     // Add any other container classes your app uses for the chat input if needed.
//     const chatSelectors = [
//       '.user-input-textarea',
//       '.chat-input',
//       '.chat-input-container',
//       '.input-container',
//       '.chat-container',
//       '.clarisandbox-input-container',
//       '.clarichat-input' // adapt / add your project's actual class names here
//     ].join(',');

//     const css = `
//       /* Ensure overlay element(s) are on top of everything */
//       app-tour-overlay,
//       app-tour-overlay .tour-overlay,
//       .tour-overlay,
//       .tour-backdrop,
//       .tour-highlight,
//       .tour-tooltip {
//         z-index: 2147483647 !important; /* very high */
//       }

//       /* Put backdrop slightly lower than tooltip/highlight but still extremely high */
//       .tour-backdrop {
//         z-index: 2147483646 !important;
//       }

//       /* Force chat/input wrappers to be behind the overlay while tour active.
//          We only push them down in stacking order; we do not change layout. */
//       ${chatSelectors} {
//         position: relative !important;
//         z-index: 0 !important;
//       }

//       /* Also ensure any immediate parents with high z-index are lowered (common case) */
//       ${chatSelectors} * {
//         z-index: 0 !important;
//       }
//     `;

//     const style = document.createElement('style');
//     style.id = this.INJECTED_GLOBAL_TOUR_STYLE_ID;
//     style.appendChild(document.createTextNode(css));
//     document.head.appendChild(style);
//   }

//   private removeGlobalTourStyle(): void {
//     const s = document.getElementById(this.INJECTED_GLOBAL_TOUR_STYLE_ID);
//     if (s) s.remove();
//   }

//   private disableScroll(): void {
//   document.body.style.overflow = 'hidden';
//   document.documentElement.style.overflow = 'hidden';
// }

// private enableScroll(): void {
//   document.body.style.overflow = '';
//   document.documentElement.style.overflow = '';
// }

// }
